<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  

        
       
       
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;">Timeline Of Company Registers</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="clients">
                	<el-table-column label="Change" property="email" ></el-table-column>
     				 <el-table-column label="Effective Date" property="effective_date_str" ></el-table-column>
               </el-table-column>
                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.initPage();
    },
    
     
    data () {
      return {
        coy:[],
        clients:[],
    	eid: this.$route.params.eid,
		account: {
          email: '',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          email: {
            required: true,
            email:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	getError(fieldName) {
        return this.errors.first(fieldName)
      },
	    createClientAccount(){
	    	 
	    },
	    initPage(){
	    	let uri = this.$base_url+'/api/v1/entities/get/company_register/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;

			})
	    },
	   
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


